<template>
    <section class="app-product-view container-fluid">
        <div class="app-view-header d-flex flex-wrap justify-content-center">
            <div class="app-view-header__headline-wrap d-flex align-items-center">
                <span class="app-view-header__headline-wrap-pseudo-helper"></span>
                <h1 class="app-view-header__headline h2" v-html="product.categories[0]"></h1>
                <span class="app-view-header__headline-wrap-pseudo-helper"></span>
            </div>
            <a :href="productGoBackUrl" class="app-view-header__go-back">&leftarrow; {{ $t('product.goBack') }}</a>
            <!-- <router-link :to="{ name: 'product-selection' }" class="app-view-header__go-back">&leftarrow; {{ $t('product.goBack') }}</router-link> -->
        </div>
        <div class="app-product-view__main">
            <div class="row">
                <div v-if="product.imageUrl" class="app-product-view__img-col col col-md-6">
                    <div class="app-product-view__img-wrap">
                        <img :src="product.imageUrl" :alt="product.name" class="app-product-view__img">
                        <div class="app-product-view__img-badges">
                            <img v-for="(badge, idx) in productBadgesSorted" :key="'badge' + idx" :src="badge.url" :alt="badge.alt" class="app-product-view__img-badge">
                        </div>
                    </div>
                </div>
                <div class="app-product-view__data col-12 col-md">
                    <div class="app-product-view__data-inner">
                        <h1 class="app-product-view__data-headline h2" v-html="product.name"></h1>
                        <ul class="app-product-view__attributes d-flex flex-wrap">
                            <li v-if="product.loadCapacity" class="app-product-view__attribute">
                                <i class="app-product-view__attribute-icon-wrap d-block" :title="$t('product.loadCapacity')">
                                    <svg class="app-product-view__attribute-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 5.6a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2zM12 8a4 4 0 110-8 4 4 0 010 8zm9.6 13.6L19.1 8H4.9L2.4 21.6h19.2zM2.03 24a2.02 2.02 0 01-2-2.38L2.66 7.26a2.02 2.02 0 012-1.66h14.69c.98 0 1.82.7 2 1.66l2.62 14.36a2.02 2.02 0 01-2 2.38H2.03z"/>
                                    </svg>
                                </i>
                                {{ product.loadCapacity }}
                            </li>
                            <li v-if="product.liftHeight" class="app-product-view__attribute">
                                <i class="app-product-view__attribute-icon-wrap d-block" :title="$t('product.liftHeight')">
                                    <svg class="app-product-view__attribute-icon" viewBox="0 0 14 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.32 9.7v13.1c0 1.6-2.74 1.6-2.74 0V9.7l-3.14 2.75c-.54.47-1.4.47-1.94 0a1.1 1.1 0 010-1.7l5.48-4.8c.54-.47 1.4-.47 1.94 0l5.49 4.8a1.1 1.1 0 010 1.7c-.54.47-1.4.47-1.94 0L8.31 9.7v13.1H5.58V9.7l.57-.5h1.6l.57.5zM1.47 2.4C.71 2.4.1 1.86.1 1.2.1.54.71 0 1.47 0h10.51c.76 0 1.37.54 1.37 1.2 0 .66-.61 1.2-1.37 1.2H1.47z"/>
                                    </svg>
                                </i>
                                {{ product.liftHeight }}
                            </li>
                            <li v-if="product.maxSpeed" class="app-product-view__attribute">
                                <i class="app-product-view__attribute-icon-wrap d-block" :title="$t('product.maxSpeed')">
                                    <svg class="app-product-view__attribute-icon" viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15 .4c7.96 0 14.38 6.63 14.4 14.79v3.21a1.2 1.2 0 11-2.4 0v-3.17c0-6.91-5.39-12.49-12-12.49S3 8.32 3 15.23v3.17a1.2 1.2 0 11-2.4 0v-3.21C.62 7.03 7.04.4 15 .4zm7.63 9.17c.5.49.5 1.28 0 1.77l-5.3 5.3A2.4 2.4 0 0115 19.6a2.4 2.4 0 11.56-4.73l5.3-5.3a1.25 1.25 0 011.77 0z"/>
                                    </svg>
                                </i>
                                {{ product.maxSpeed }}
                            </li>
                        </ul>
                        <div v-if="product.description" class="app-product-view__description" v-html="product.description"></div>
                        <a v-if="product.dataSheetUrl" :href="product.dataSheetUrl" class="app-product-view__shop-detail-page-link" target="_blank" download>&downarrow; {{ $t('product.downloadDataSheet') }}</a>

                        <div class="app-product-view__price-box row">
                            <div class="app-product-view__price col-12 col-sm">
                                <b v-if="product.price > 0" class="app-product-view__price-tag d-block">
                                    <small v-if="pricePrefix" class="app-product-view__price-tag-prefix" v-html="pricePrefix"></small>
                                    {{ nEnhanced(product.price, 'currency') }}
                                    <template v-if="product.pricePeriod === 'day'">{{ $t('misc.perDay') }}</template>
                                    <template v-else>{{ $t('misc.perWeek') }}</template>
                                </b>
                                <b v-else class="app-product-view__price-tag d-block">{{ $t('misc.priceOnRequest') }}</b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="app-view-footer app-product-view__footer">
            <div class="app-view-footer__inner row flex-column flex-md-row justify-content-md-around align-items-center align-items-md-start">
                <div class="app-view-footer__col col">
                    <div class="app-view-footer__btn-wrap">
                        <button type="button" class="app-view-footer__btn btn btn--primary" :class="{ 'app-view-footer__btn--hidden': currentStep > 0 }" @click="goForward">{{ $t('product.goForward') }} &downarrow;</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { sortBy } from 'lodash'

export default {
    name: 'Product',
    data: () => ({
        productGoBackUrl: process.env.VUE_APP_PRODUCT_GO_BACK_URL
    }),
    computed: {
        product: (vm) => vm.$store.getters.productMapped,
        productPathSegment: (vm) => vm.$store.state.productPathSegment,
        productBadgesSorted: (vm) => sortBy(vm.product.badges, 'sorting'),
        currentStep: (vm) => vm.$store.state.currentStep,
        pricePrefix: (vm) => vm.product.pricePeriod === 'day' && vm.tExists('product.perDayPrefix') ? vm.$t('product.perDayPrefix') : undefined
    },
    methods: {
        goForward () {
            if (this.currentStep < 1) {
                this.$store.commit('setCurrentStep', 1)
            }

            this.$router.push({
                name: 'steps',
                hash: '#price-calculation',
                params: {
                    productPathSegment: this.productPathSegment
                }
            })
        }
    },
    created () {
        this.productGoBackUrl = process.env.VUE_APP_PRODUCT_GO_BACK_URL + window.location.search
    }
}
</script>

<style scoped>
    .app-product-view {
        position: relative;
        max-width: 1200px;
        padding-bottom: 20px;
    }
    .app-product-view__main {
        margin-bottom: 2em;
        background-color: #fff;
    }
    .app-product-view__img-col {
        max-width: 400px;
    }
    .app-product-view__img-wrap {
        position: relative;
        padding-bottom: 100%;
    }
    .app-product-view__img {
        position: absolute;
        left: 0;
        top: 0;
    }
    .app-product-view__img-badges {
        position: absolute;
        left: 10px;
        top: 10px;
    }
    .app-product-view__img-badge {
        width: 60px;
        height: 60px;
        margin-bottom: 10px;
    }
    .app-product-view__data-inner {
        padding: 15px;
    }
    .app-product-view__data-headline {
        margin-bottom: 1em;
    }
    .app-product-view__attributes {
        margin: -10px 0 1.8em;
        padding: 0;
        list-style: none;
    }
    .app-product-view__attribute {
        flex: 0 0 85px;
        max-width: 85px;
        padding: 10px 8px 0;
        font-size: .8em;
        text-align: center;
        color: #545454;
        border-right: 1px solid #cbc9c8;
    }
    .app-product-view__attribute:last-child {
        border-right: 0;
    }
    .app-product-view__attribute-icon-wrap {
        margin-bottom: .6em;
    }
    .app-product-view__attribute-icon {
        width: 25px;
        height: 25px;
        max-width: 100%;
        max-height: 100%;
        fill: #969492;
    }
    .app-product-view__description {
        margin-bottom: 20px;
    }
    .app-product-view__description >>> ul {
        padding-left: 1.2em;
    }
    .app-product-view__shop-detail-page-link {
        display: inline-block;
        margin: -.5em -.5em 20px;
        padding: .5em;
        font-weight: 500;
        text-decoration: none;
    }
    .app-product-view__price {
        padding-top: 15px;
        text-align: right;
    }
    .app-product-view__price-tag {
        margin-bottom: .4em;
        font-size: 2em;
        color: #f96915;
    }
    .app-product-view__price-tag-suffix {
        margin-left: .5em;
        font-size: .6em;
    }
    .app-product-view__price-note {
        font-size: .8em;
        color: #969492;
    }

    @media ( min-width: 768px ) {
        .app-product-view__img-col {
            max-width: none;
        }
        .app-product-view__data-inner {
            padding: 30px;
            padding-left: 15px;
        }
        .app-product-view__attribute {
            flex-basis: 100px;
            max-width: 100px;
            font-size: 1em;
        }
    }

    @media ( min-width: 992px ) {
        .app-product-view__data-inner {
            padding: 60px;
            padding-left: 30px;
        }
    }
</style>
